import script from "./ButtonSpinner.vue?vue&type=script&setup=true&lang=ts"
export * from "./ButtonSpinner.vue?vue&type=script&setup=true&lang=ts"

import "./ButtonSpinner.vue?vue&type=style&index=0&id=cce437c4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cce437c4"]])

export default __exports__